import React from 'react';
import '../styles.css';
import { YOUTUBE_PT } from '../const';
import BackButton from '../../PT/COMPONENTS/BackButton';
import { GradientBackground } from '../../PT/COMPONENTS/Background';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { YOUTUBE } from '../../HOME/const';
import ContactButton from '../../HOME/COMPONENTS/ContactButton';

const HelpPage = () => {
  return (
    <div className="page-root pt-page" style={{ backgroundImage: GradientBackground }}>
      <div className="home-center-button-toolbar">
        <ContactButton size={36} service={YOUTUBE} url={YOUTUBE_PT} />
      </div>
      <BackButton />
      <HomeButton />
    </div>
  );
};

export default HelpPage;
